import Navbar from '../shared/Navbar'
import TittleBanner from '../shared/TittleBanner'
import DescBanner from '../shared/DescBanner'
import Carousel from 'react-multi-carousel'
import expertise from '../assets/images/svgs/expertise.png'
import care from '../assets/images/svgs/care.png'
import onTime from '../assets/images/svgs/on-time.png'
import satisfaction from '../assets/images/svgs/satisfaction.png'
import target from '../assets/images/svgs/target.png'
import quality from '../assets/images/svgs/high-quality.png'
import trust from '../assets/images/svgs/trust.png'
import Footer from '../Footer/footer'

export default function About() {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 1
    }
  };
  return (
    <div>
      <Navbar/>
      <TittleBanner tiitle="About Us" img="bg-about-us-banner"/>
      <DescBanner text="At Arcium Studio, we believe that architecture is more than just design—it’s about shaping spaces that enhance lives and stand the test of time. With a deep passion for creativity and functionality, we specialize in residential, commercial, and interior architecture, delivering innovative and sustainable solutions tailored to each client’s vision. Our approach combines precision, artistry, and a deep understanding of materials and space to create timeless designs. Whether it’s a modern home, a dynamic commercial space, or a renovation project, we work closely with our clients to bring their ideas to life with unmatched attention to detail. With years of experience in the industry, Arcium Studio is committed to excellence, ensuring every project is a perfect blend of aesthetics, functionality, and sustainability. Let’s build something extraordinary together!"/>
    
      <h1 className='text-center text-2xl sm:text-3xl font-orbitron mt-16'>OUR PRIORITY</h1>
                <div className='flex items-center justify-center'>
                    <Carousel responsive={responsive} className='flex items-center justify-between align-middle p-5 mb-10 mt-10 h-[400px]'>
                    {data.map((d) => 
                    <div className='flex justify-center items-center p-6'>
                         <div className='ease-in-out hover:cursor-pointer w-64 p-5 h-80 bg-color1 gap-5 rounded-3xl flex flex-col items-center justify-center'>
                         <img src={d.img} alt="" />
                         <h1 className='text-background text-2xl font-bold font-roboto'>{d.title}</h1>
                         <p className='text-background text-xl text-center font-roboto'>{d.description}</p>
                     </div>
                     </div>
                    )}
                    </Carousel>            
                </div>

    <Footer/>
    </div>
  )
}

const data = [ 
  {img: expertise, title: "Expertise", description: "We do our work with expertise."},
  {img: onTime, title: "Punctuality", description: "We are always on time."},
  {img: satisfaction, title: "Satisfaction", description: "Customer satisfaction is our priority."},
  {img: care, title: "Care", description: "We take care of your home as if it were our own."},
  {img: target, title: "Precision", description: "Perfection down to the smallest detail."},
  {img: quality, title: "Quality", description: "High-quality materials for long-lasting results."},
  {img: trust , title: "Trust", description: "Honest advice, reliable work."},
]
